const contact = {
  path: '/contact',
  title: "Let's Connect",
  email: 'nicholas.chumney@outlook.com',
  phone: '(905) 626 9950',
};

export default contact;
